import { FC } from 'react'
import ReactMarkdown from 'react-markdown'

type Props = {
  content: string
  /**
   * The answer is still being written. Renders a caret at the tail of the text
   * INSIDE this bubble — the cue used to be a separate assistant row, which is
   * what made one streaming answer look like two messages.
   */
  streaming?: boolean
}

/**
 * `dir='auto'` — direction follows the ANSWER, not the app locale. A Persian
 * reply in the English UI must read right-to-left and an English reply in the
 * Persian UI left-to-right, and only the content knows which. The browser's
 * first-strong-character heuristic decides, so no script detector ships here.
 *
 * It is re-evaluated as `content` grows, which is what makes it right for the
 * streaming case too: the first token that carries a strong character settles
 * the bubble, rather than it being pinned by an empty opening chunk.
 *
 * Whole-bubble granularity is deliberate. Per-paragraph direction would mean
 * overriding react-markdown's element renderers; instead `chat.scss` gives the
 * markdown blocks `unicode-bidi: plaintext`, so a mixed-language answer still
 * orders each paragraph by its own script (alignment stays the bubble's).
 */
const AnswerBubble: FC<Props> = ({ content, streaming = false }) => (
  <div className='lum-bubble-ai' dir='auto'>
    <ReactMarkdown>{content}</ReactMarkdown>
    {streaming ? <span className='lum-caret' data-testid='stream-caret' aria-hidden='true' /> : null}
  </div>
)

export default AnswerBubble
